import classnames from 'classnames';
import { Link } from 'gatsby';
import React from 'react';

interface HeaderProps {
  className ? : string;
}

export default function Header (props: HeaderProps): JSX.Element {
  const { className } = props;
  return (
    <Link to="/">
      <header className={classnames(
        'logo',
        className,
      )}>
        Yesanēchi
      </header>
    </Link>
  );
}
